export class Education {
    id: string;
    highestGradeCompleted: string;
    lastSchoolAttended: string;
    certification: string;
    specialCourses: string;
}
